<template>
    <div>
        <header>
            <div class="container header-container">
                <div class="navbar-header">
                    <button type="button" class="navbar-toggle" @click="toggleNav()">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>
                    <a class="navbar-brand" href="/">
                        <img src="/api/public/img/torindrivena.png" alt="Torin Drive North America" class="img-responsive">
                    </a>
                </div>
                <div v-show="showNav" class="navbar-wrap">
                    <ul class="nav">
                        <li id="dashboard-link-mobile" class="menu-item">
                            <router-link to="/dashboard" class="log-item dashboard-link-mobile"><span class="fa fa-user"></span> Dashboard</router-link>
                        </li>
                        <li class="menu-item" v-for="menu in mainMenu" :key="menu.name">
                            <a :href="menu.url" :target="menu.target ? menu.target : '_self'" @click="toggleSubNav($event)">{{menu.name}}</a>
                            <ul class="sub-nav" v-if="menu.children">
                                <li class="menu-item" v-for="menu in menu.children" :key="menu.name">
                                    <a :href="menu.url" :target="menu.target ? menu.target : '_self'" @click="toggleSubNav($event)">{{menu.name}}</a>
                                    <ul class="sub-nav" v-if="menu.children">
                                        <li class="menu-item" v-for="menu in menu.children" :key="menu.name">
                                            <a :href="menu.url" :target="menu.target ? menu.target : '_self'">{{menu.name}}</a>
                                        </li>
                                    </ul> 
                                </li>
                            </ul> 
                        </li>
                        <li class="menu-item b-bottom-0">
                            <a href="javascript:void(0);" id="search-btn" @click="showSearchBox = !showSearchBox"><img src="/api/public/img/icon-search.png" alt="Torin Drive North America"></a>
                            <div class="search-mobile">
                                <form role="search" method="get" class="navbar-form" action="/">
                                    <div class="search-wrapper">
                                        <div class="form-group">
                                            <input type="text" class="form-control" placeholder="Search" value="" name="s">
                                        </div>
                                        <button type="submit" value="Search"><i class="fa fa-search"></i></button>
                                    </div>
                                </form>					
                            </div>
                        </li>
                        <li class="log-wrap">
                            <span v-if="showMenu">
                                <router-link v-if="user.role === 'project-manager' || user.role === 'administrator' || user.role === 'super_admin'" to="/projects" class="log-item"><span class="fa fa-user"></span> Dashboard</router-link>
                                <router-link v-else to="/dashboard" class="log-item"><span class="fa fa-user"></span> Dashboard</router-link>
                                <router-link to="/logout" class="btn btn-primary">Logout</router-link>
                            </span>
                            <span v-else>
                                <router-link to="/login" class="btn btn-primary">Login</router-link>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </header>
        <div v-show="showSearchBox" class="search-desktop">
            <div class="container">
                <form role="search" method="get" class="navbar-form" action="/">
                    <div class="search-wrapper">
                        <div class="form-group">
                            <input type="text" class="form-control" placeholder="Search" value="" name="s">
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="title-bar">
            <h1>{{ $route.name }}</h1>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            user: {},
            showNav: true,
            showMenu: true,
            showSearchBox: false,
            windowWidth: window.innerWidth,
            mainMenu: {
                "home":{
                    "url":"/north-america/",
                    "name":"Home"
                },
                "product_and_solutions":{
                    "url":"#",
                    "name":"Product and Solutions",
                    "children":[
                        {
                            "url":"#",
                            "name":"Modernization",
                            "children": [
                                {
                                    "url": "/product-and-solutions/modernization/geared-replacement/",
                                    "name": "Geared Replacement"
                                },
                                {
                                    "url": "/product-and-solutions/modernization/ac-geared-or-dc-to-ac-gearless/",
                                    "name": "AC Geared Or DC To AC Gearless"
                                },
                                {
                                    "url": "/product-and-solutions/modernization/basement-machines/",
                                    "name": "Basement Machines"
                                },
                                {
                                    "url": "/product-and-solutions/modernization/on-site-service/",
                                    "name": "On-Site Service"
                                }
                            ]
                        },
                        {
                            "url":"/product-and-solutions/new-construction/machine-roomless/",
                            "name":"New Construction",
                            "children": [
                                {
                                    "url": "/product-and-solutions/new-construction/machine-roomless/",
                                    "name": "Machine Roomless"
                                },
                                {
                                    "url": "/product-and-solutions/new-construction/heavy-duty/",
                                    "name": "Heavy Duty Gearless"
                                },
                                {
                                    "url": "/product-and-solutions/new-construction/basement-machines/",
                                    "name": "Basement Machines"
                                },
                                {
                                    "url": "/product-and-solutions/new-construction/overhead-geared/",
                                    "name": "Overhead Geared"
                                }
                            ]
                        },
                        {
                            "url":"/product-and-solutions/elevator-components/",
                            "name":"Elevator Components"
                        },
                        {
                            "url":"/stock-machine-systems/",
                            "name":"Stock Machine Systems"
                        },
                        {
                            "url":"/project/spare-parts",
                            "name":"Spare Parts Shop"
                        },
                        {
                            "url":"/quote/",
                            "name":"Survey Forms"
                        }
                    ]
                },
                "technical_support":{
                    "url":"#",
                    "name":"Technical Support",
                    "children":[
                        {
                            "url":"/technical-support/contact-us/",
                            "name":"Technical Support Contact"
                        },
                        {
                            "url":"/project/technical-documents",
                            "name":"Technical Documents"
                        },
                        {
                            "url":"/project/service-videos",
                            "name":"Service Videos"
                        },
                        {
                            "url":"/project/brakeadjustment",
                            "name":"Brake Adjustments"
                        }
                    ]
                },
                "uscareers":{
                    "url":"/uscareers/",
                    "name":"Careers"
                },
                "warranty":{
                    "url":"#",
                    "name":"Warranty",
                    "children":[
                        {
                            "url":"/api/public/files/additional/warranty.pdf",
                            "name":"Policy",
                            "target":"_blank"
                        },
                        {
                            "url":"/project/warranty-claim",
                            "name":"Submit Claim"
                        }
                    ]
                },
                "hyperion_brands":{
                    "url":"#",
                    "name":"Hyperion Brands",
                    "children":[
                        {
                          "url":"https://www.capitalelectricmotor.com/",
                          "name":"CAPITAL ELECTRIC",
                          "target":"_blank"
                        },
                        {
                            "url":"https://www.elevatorequipment.com/home-page",
                            "name":"EECO",
                            "target":"_blank"
                        },
                        {
                            "url":"https://www.emiporta.com",
                            "name":"EMI PORTA",
                            "target":"_blank"
                        },
                        {
                            "url":"https://goodgate.ca/",
                            "name":"GOODGATE",
                            "target":"_blank"
                        },
                        {
                            "url":"https://www.mcintoshindustries.com",
                            "name":"MCINTOSH INDUSTRIES",
                            "target":"_blank"
                        },
                        {
                            "url":"https://texacone.com",
                            "name":"TEXACONE",
                            "target":"_blank"
                        },
                        {
                            "url":"https://www.titanmachine.com",
                            "name":"TITAN MACHINE",
                            "target":"_blank"
                        },
                        {
                            "url":"https://www.vatoraccessories.com",
                            "name":"VATOR ACCESSORIES",
                            "target":"_blank"
                        },
                        {
                            "url":"http://zzipco.com",
                            "name":"ZZIPCO",
                            "target":"_blank"
                        }
                    ]
                }
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.onWindowResize)
        this.toggleNavs(this.windowWidth)
    },
    watch: {
        windowWidth(newWidth) {
            this.toggleNavs(newWidth)
        }
    },
    methods: {
        onWindowResize() {
            this.windowWidth = window.innerWidth
        },
        toggleNavs(width) {
            this.showNav = false
            this.hideSubNavs()

            if(width >= 768) {
                this.showNav = true
                this.showSearchBox = false
            }
        },
        toggleNav() {
            this.showNav = !this.showNav
            this.hideSubNavs()
        },
        toggleSubNav(event) {
            let sub_nav = event.path[1].children[1]
            let parent_sub_nav = event.path[3].children[1]

            if(sub_nav.style.display != 'block') {
                this.hideSubNavs()
                if(parent_sub_nav) {
                    parent_sub_nav.style.display = 'block'
                }
                sub_nav.style.display = 'block'
            } else {
                sub_nav.setAttribute('style', '')
            }
        },
        hideSubNavs() {
            let sub_navs = document.getElementsByClassName('sub-nav')
            for(let x = 0; x < sub_navs.length; x++) {
                sub_navs[x].setAttribute('style', '')
            }
        }
    },
    beforeMount() {
        this.user = JSON.parse(localStorage.getItem('user'))
        this.showMenu = this.user && true
    },
    beforeDestroy() { 
        window.removeEventListener('resize', this.onWindowResize)
    }
}
</script>
<style lang="scss" scoped>
.log-wrap { 
    .btn-primary {
        width: 106px;
        padding: 6px !important;
    }
}
.dashboard-link-mobile {
    background: #fff !important;
    color: #102e6c !important;
}
.b-bottom-0 {
    border-bottom: 0 !important;
}
</style>
